export default function Reviews() {
  return (
    <section data-aos="flip-up" className="py-16 bg-black text-white text-center">
      <h2 className="text-3xl mb-6">Reviews</h2>

      <p className="max-w-xl mx-auto italic">
        "Best internship experience with real-world exposure."
      </p>
    </section>
  );
}